import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { Button, Grid, Paper, Modal } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import InputIcon from '@material-ui/icons/Input';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { handleCompanyUrl } from 'utils/organizationUtils';

export const PermissionDenidedDialog: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();

  const {
    userStore: { logout },
  } = useStore();

  const [open, setOpen] = useState<boolean>(true);

  const logoutReq = useMutation(() => logout(), {
    mutationKey: 'logoutReq',
    onSuccess: () => {
      setOpen(false);
      history.push(handleCompanyUrl('/login'));
    },
  });

  useAppPreloader(logoutReq.isLoading);

  const handleGoToDasboard = (): void => {
    setOpen(false);
    history.push(handleCompanyUrl('/'));
  };

  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <p className={classes.title}>Permission Denided</p>
        <p className={classes.text}>You haven't access to this section</p>
        <Grid className={classes.buttonBox} container justify='space-between'>
          <Button
            className={classes.actionBtn}
            startIcon={<DashboardIcon />}
            variant='contained'
            color='primary'
            onClick={handleGoToDasboard}
          >
            Go to Dashboard
          </Button>
          <Button
            className={classes.greyBtn}
            variant='contained'
            startIcon={<InputIcon />}
            onClick={() => logoutReq.mutate()}
          >
            Sign in
          </Button>
        </Grid>
      </Paper>
    </Modal>
  );
});
